<script setup lang="ts">
import { UserAvatar, IconRespond, IconCross } from '#shared'
import { computed, toRef } from 'vue'
import { useCancelRespond } from '#features/message-responds'
import { useMessagePreview, type Message } from '#entities/message'

const { respondFor } = defineProps<{ respondFor: Message }>()

const chatId = computed(() => respondFor.chatId)

const respondPreview = useMessagePreview(toRef(() => respondFor))
const cancelRespond = useCancelRespond(chatId)
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.body">
      <div :class="$style.sender">
        <IconRespond :class="$style.icon" />
        <UserAvatar :class="$style.senderAvatar" size="tiny" :user="respondFor.sender" />
        <span :class="$style.name">
          {{ respondFor.sender.displayName }}
        </span>
      </div>

      <span :class="$style.content">
        {{ respondPreview }}
      </span>
    </div>

    <button :class="$style.cancel" @click="cancelRespond">
      <IconCross />
    </button>
  </div>
</template>

<style lang="scss" module>
@use '#mixins/button' as button;

.root {
  margin-bottom: 10px;
  display: flex;
  gap: 10px;
}

.body {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.sender {
  display: flex;
  align-items: center;
  width: fit-content;
}

.icon {
  margin-right: 15px;
}

.senderAvatar {
  margin-right: 5px;
}

.content {
  font-size: 14px;
  opacity: 0.6;
}

.cancel {
  @include button.reset;

  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.1s;
  margin-left: auto;

  &:hover {
    color: var(--sc-error);
  }
}
</style>
